export default "__VITE_ASSET__Durrw9E0__"